module.exports = __webpack_public_path__ + "static/media/V.f45e6268.png";